export default __webpack_public_path__ + "static/media/Zhero-Logo-Branco.26b269c4.png";